document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.logo-list__item.bg-custom img.logo-list__image').forEach(img => {
        let parent = img.closest('.logo-list__item.bg-custom');
        if (parent && img.alt) {
            parent.setAttribute('title', img.alt);
            console.log("Добавлен title:", img.alt); // Проверяем в консоли
        }
    });
});